// The per-client accent is data, not a design token, so it is published as a CSS
// custom property and consumed in reportDashboard.scss as
// var(--dashboard-accent, $light-primary-color). Clearing it when a client has no
// accent lets the SCSS fallback (the app's primary colour) take over.
export function applyAccentColor(accentColor) {
  const root = document.documentElement;
  if (accentColor) {
    root.style.setProperty("--dashboard-accent", accentColor);
  } else {
    root.style.removeProperty("--dashboard-accent");
  }
}
